import { Pipe, PipeTransform } from '@angular/core';
import { moment } from '../lib/moment';
import { Session } from '../services/session';

@Pipe({ name: 'contextualTimestamp' })
export class ContextualTimestampPipe implements PipeTransform {
  constructor(private session: Session) {}

  public transform(dateTime) {
    dateTime = moment(dateTime);
    if (!dateTime.isValid) return '';

    let format: string = 'MM/DD/YYYY';
    if (dateTime.isSame(moment(), 'year')) {
      format = 'MM/DD, hh:mm A z';
    }
    return dateTime.mapTz(this.session.getUserTimeZone()).format(format);
  }
}
